<template>
  <div class="textExpand">
    <div class="info" @click="showTotalIntro" tabindex="0">
      <div class="introduce">
        <div class="intro-content" :class="showTotal ? 'unfold' : 'fold'" :data-content="textNobr" ref="desc">
          <span class="merchant-desc" v-if="text" v-html="text"></span>
          <div class="control" v-if="showExchangeButton">
            <v-icon class="arrow-down" name="arrow-right-v3" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import create from '../create'
export default create({
  name: 'text-expand',
  props: {
    text: {
      type: String,
      default() {
        return ''
      }
    }
  },
  computed: {
    textNobr () {
      return this.text.replaceAll('<br>', ' ').replaceAll('<br/>', ' ')
    }
  },
  data() {
    return {
      // 是否展示所有文本内容
      showTotal: true,
      // 是否显示展开收起按钮
      showExchangeButton: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.$refs.desc) {
        return
      }
      // 获取文本行数，超出两行展示查看更多按钮
      let textLines = document.querySelector('.merchant-desc').getClientRects().length
      // 显示展开收起按钮
      this.showExchangeButton = textLines > 2
      this.showTotal = !this.showExchangeButton
    })
  },
  methods: {
    // 切换箭头
    showTotalIntro() {
      if (this.showExchangeButton) {
        this.showTotal = !this.showTotal
      }
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
